var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownDotted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5H19L19 10.5H17V12.5H15L15 14.5H13V16.5L11 16.5V14.5L9 14.5L9 12.5H7V10.5H5V8.5H7V10.5H9V12.5H11V14.5H13V12.5L15 12.5V10.5H17L17 8.5Z",
    fill: "#1A5C4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownDotted);
export default __webpack_public_path__ + "static/media/arrow-down-dotted.32f42f3ca5c56dd457522228aee1d839.svg";
export { ForwardRef as ReactComponent };